import React from "react";
import { Modal, Box } from "@mui/material";
import PdfViewer from "./PdfViewer";

// PdfViewer is a function component and cannot accept a ref directly. MUI's
// Modal requires a child that can hold a ref (DOM element or a component that
// forwards refs). Wrap PdfViewer in a Box (which forwards refs) to satisfy
// Modal's requirement.
export const PdfModal = ({ source, closeModal }) => {
  return (
    <Modal
      open={Boolean(source)}
      onClose={closeModal}
      aria-labelledby="pdf-modal"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: { xs: 0.5, sm: 1 },
          borderRadius: 1,
          width: { xs: "95vw", sm: "90vw" },
          maxWidth: "1200px",
          height: { xs: "90dvh", sm: "80vh" },
          overflow: "hidden",
        }}
      >
        <PdfViewer fileName={source} onClose={closeModal} />
      </Box>
    </Modal>
  );
};
